<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <loading
        :active.sync="loading"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
    <Header />

    <b-card class="bCardGlobal">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span
          ><b-icon icon="file-earmark-check" aria-hidden="true"></b-icon
          ></span>
          <span>Bandeja de acciones de Avpt</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Bj_acciones_AVPT</div>
        </b-col>
      </b-row>

      <div class="divSubtitulo">
        <p class="textSubtitulo">Consulta de estatus por Avpt</p>
      </div>
      <b-form v-if="tipoBusqueda == 1" @submit.stop.prevent="filtrado">

        <div class="row">
          <b-col cols="4">
            <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
              <label>Fecha inicio de actividad programada:<validacion/></label>
              <b-input-group size="sm" class="mb-2">
                <b-form-datepicker placeholder="Fecha inicio"
                                   :max="new Date()"
                                   @input="fechaMaxima($event)"
                ></b-form-datepicker>
              </b-input-group>
              <b-form-invalid-feedback :state="filtro.fechaInicio != null">
                Este campo es obligatorio
              </b-form-invalid-feedback>
            </validation-provider>
          </b-col>

          <b-col cols="4">
            <validation-provider name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
              <label>Fecha fin de actividad programada:<validacion/></label>
              <b-input-group size="sm" class="mb-2">
                <b-form-datepicker placeholder="Fecha fin"
                                   v-model="filtro.fechaFin"
                                   :max="filtro.fechaInicio.addDays(diasMaximoMes) > new Date() ? new Date(): filtro.fechaInicio.addDays(diasMaximoMes)"
                                   :min="filtro.fechaInicio"
                ></b-form-datepicker>
              </b-input-group>
              <b-form-invalid-feedback :state="filtro.fechaFin != null">
                Este campo es obligatorio
              </b-form-invalid-feedback>
            </validation-provider>
          </b-col>
          <!--<div class="col" v-if="$localStorageService.can('Acci_01_avpt_BJ_status')">
            <b-form-group align="left">
              <label
                >Estatus
              </label>
              <b-input-group size="sm" class="mb-2 row">
                <v-select
                  class="col-11"
                  id="nombreMenu"
                  name="nombreMenu"
                  placeholder="Estatus"
                  v-model="idEstatusFiltro"
                  label="nombreEstatus"
                  style="width: 95%"
                  required
                  :reduce="(variable) => variable.idEstatus"
                  :options="coloresFiltrado"
                  multiple
                >
                  <template v-slot:option="option">
                    <em
                        class="fa fa-circle"
                        :style="{ color: option.codigoColor }"
                    >
                    </em>
                    {{ option.nombreEstatus }}
                  </template>
                </v-select>
              </b-input-group>
            </b-form-group>
          </div>
        </div>-->
          <div class="col" v-if="$localStorageService.can('Acci_01_avpt_BJ_status_tx')">
            <b-form-group align="left">
              <label
              >Estatus Tx
              </label>
              <b-input-group size="sm" class="mb-2 row">

                <v-select
                    class="col-11"
                    id="nombreMenu"
                    name="nombreMenu"
                    placeholder="Estatus"
                    v-model="idEstatusFiltroTx"
                    label="nombre"
                    style="width: 95%"
                    required
                    :reduce="(variable) => variable.value"
                    :options="coloresTx"
                    multiple
                >
                  <template v-slot:option="option">
                    <em class="fa fa-circle" :style="{ color: option.codigoColor }">
                    </em>
                    {{ option.nombre }}
                  </template>
                </v-select>
              </b-input-group>

            </b-form-group>
          </div>
        </div>
        <div class="row">
          <div class="col-10" v-if="$localStorageService.can('Acci_01_avpt_BJ_clini')">
            <b-form-group align="left">
              <label>Clínicas</label>
              <v-select
                  style="width: 100%"
                  name="clinica"
                  placeholder="--Seleccionar--"
                  label="nombreClinica"
                  multiple
                  :reduce="(variable) => variable.idClinica"
                  :options="listaClinicas"
                  v-model="filtro.clinica"
              ><span slot="no-options">No hay clínicas disponibles</span>
              </v-select>
            </b-form-group>
            <b-form-invalid-feedback
                :state="filtro.clinica != null && filtro.clinica.length > 0"
            >
              Este campo es obligatorio
            </b-form-invalid-feedback>
          </div>
          <div class="col-2 mt-4" v-if="$localStorageService.can('Acci_01_avpt_BJ_add_clini')">
            <b-button
                v-if="todas"
                class="btnn"
                variant="outline-primary"
                v-b-tooltip.hover
                @click="todos()"
            >
              <b-icon icon="check2-all"></b-icon>
              <span class="labels">Seleccionar Todas</span>
            </b-button>
            <b-button
                v-else
                class="btnn"
                variant="outline-primary"
                v-b-tooltip.hover
                @click="clear()"
            >
              <b-icon icon="x"></b-icon>
              <span class="labels">Quitar todas</span>
            </b-button>
          </div>
        </div>

        <div>
          <b-button class="m-5" variant="outline-primary" type="submit" v-if="$localStorageService.can('Acci_01_avpt_BJ_btn_buscar')"
          >Buscar</b-button
          >
        </div>
      </b-form>
      <b-row v-if="tipoBusqueda == 2 || tipoBusqueda == 3">
        <b-col  >
          <div class="d-flex justify-content-center">
            <b-row class="barra d-flex justify-content-between">
              <div class="col-sm-12 col-md-10 d-flex text-left">
                <font-awesome-icon
                    style="color: gray"
                    class="m-auto m-1"
                    icon="filter"
                />
                <b-form-input
                  v-if="tipoBusqueda == 2"
                    class="ml-3 input-filter"
                    style="border:0"
                    placeholder="ID de PTI"
                    v-model="filtro.idPTI"
                ></b-form-input>
                <b-form-input
                  v-if="tipoBusqueda == 3"
                    class="ml-3 input-filter"
                    style="border:0"
                    placeholder="ID del paciente"
                    v-model="filtro.idPaciente"
                ></b-form-input>
              </div>

         
              <div class="col-md-1  col-sm-12 text-right">
                <b-button
                    variant="primary"
                    :disabled="loader"
                    @click="filtrado(true)"
                >
                  <span v-if="!loader"
                  ><font-awesome-icon icon="search"
                  /></span>
                  <span v-else><b-spinner small></b-spinner></span>
                </b-button>
              </div>
            </b-row>
          </div>
        </b-col>
      </b-row>  


      <b-form-group v-slot="{ ariaDescribedbyTipoBusqueda }">
        <b-form-radio-group
            id="btn-tipos_busqueda_paciente"
            v-model="tipoBusqueda"
            :aria-describedby="ariaDescribedbyTipoBusqueda"
            button-variant="outline-primary"
            size="sm"
            name="radio-btn-outline"
        >
        <b-form-radio value="1" v-if="$localStorageService.can('Acci_01_avpt_BJ_fecha')" @change="cambioFiltro(1)">Busq. por fechas</b-form-radio>
        <b-form-radio value="2" v-if="$localStorageService.can('Acci_01_avpt_BJ_idpx')" @change="cambioFiltro(2)">Busq. por ID de PTI</b-form-radio>
        <b-form-radio value="3" v-if="$localStorageService.can('Acci_01_avpt_BJ_idpti')" @change="cambioFiltro(3)">Busq. por ID de paciente</b-form-radio>
      </b-form-radio-group>
      </b-form-group>

      <!--      Inico de la tabla AVPT Bandeja-->
      <div id="contenedor" class="row">
        <b-tabs class="col-12">
          <b-tab @click="tabSeleccionada = 1" title="Nuevos" active>
            <div id="tabla1" class="my-auto mx-auto scrollme">
              <b-table
                  id="Pendientes"
                  :sticky-header="true"
                  thead-tr-class="columnas"
                  :items="datosTabla"
                  :fields="fields"
                  
              >
                <template v-slot:cell(nombrePaciente)="row">
                  <router-link
                      :to="{
                      name: 'avpt',
                      params: { idPaciente: row.item.idPaciente },
                    }"
                  >
                    <div class="spanCien">
                      <span
                          v-if="row.item.nombrePaciente != null"
                          style="color: #087372"
                      >
                        {{ row.item.nombrePaciente }}
                      </span>
                      <span v-else style="color: #000000">
                        {{ row.item.nombrePaciente }}
                      </span>
                    </div>
                  </router-link>
                </template>
                <template v-slot:cell(clasificacion)="row">
                  {{ row.item.clasificacion }}
                  <b-icon
                      icon="star-fill"
                      aria-hidden="true"
                      font-scale="1.5"
                      :style="{ color: row.item.colorClasificacion }"
                  ></b-icon>
                </template>
                <template v-slot:cell(estatus)="row">
                  <b-icon
                      v-b-tooltip.hover
                      :title=" ' Estatus general pti ' "
                      icon="circle-fill"
                      aria-hidden="true"
                      font-scale="2"
                      :style="{ color: row.item.colorEstatusPti }"
                  ></b-icon>
                </template>
                <template v-slot:cell(colorEstatus)="row">
                  <b-icon
                      v-b-tooltip.hover
                      :title=" ' Estatus tratamiento ' "
                      icon="circle-fill"
                      aria-hidden="true"
                      font-scale="2"
                      :style="{ color: row.item.colorEstatus }"
                  ></b-icon>
                </template>}
                <template v-slot:cell(comentarioActividadAsignada)="row">
                  <div v-if="row.item.comentarioActividadAsignada == '' && row.item.idTipoAccion == null">
                    <p>Asignación de tipo "No contactar"</p>
                  </div>
                  <div v-else>
                    {{row.item.comentarioActividadAsignada}}
                  </div>
                </template>

                <template v-slot:cell(programarActividad)="row" v-if="$localStorageService.can('Acci_01_avpt_BJ_prog_act')">
                  <b-button
                    pill
                    variant="info"
                    @click="programarActivdiad(row.item)"
                    :disabled="row.item.idEstatusAccion === 2 || row.item.idTipoAccion == null"
                    >Actividad</b-button
                  >
                </template>
                <template v-slot:cell(idEstatusAccion)="row">
                  <b-icon
                      v-if="row.item.idEstatusAccion === 1"
                      icon="x-circle-fill"
                      scale="2"
                      variant="danger"
                      v-b-popover.hover.top="'Actividad No Realizada'"
                      class="mLeft"
                  >
                  </b-icon>
                  <b-icon
                      v-if="row.item.idEstatusAccion === 2"
                      icon="check-circle-fill"
                      scale="2"
                      variant="success"
                      v-b-popover.hover.top="'Actividad Realizada'"
                      class="mLeft"
                  >
                  </b-icon>
                </template>
                <template v-slot:cell(fechaActividadAsignada)="row">
                  <div v-if="row.item.fechaActividadAsignada != null" >
                    {{ row.item.fechaActividadAsignada | formatoFechaHora}}
                  </div>
                  <div v-else>
                    <p>Sin fecha</p>
                  </div>

                </template>
                <template v-slot:cell(fechaActividadRealizada)="row">
                  <div v-if="row.item.idEstatusAccion === 2" >
                    {{ row.item.fechaActividadRealizada | formatoFechaHora}}
                  </div>
                  <div v-else>
                    <p>Sin fecha</p>
                  </div>

                </template>
                <template v-slot:cell(porcentajeFinanciero)="row">
                  <span>{{ row.item.porcentajeFinanciero }}%</span>
                </template>
                <template v-slot:cell(avanceSalud)="row">
                  <span>{{ row.item.avanceSalud }}%</span>
                </template>
                <div align="center" v-if="loader">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                </div>
              </b-table></div
          ></b-tab>
          <b-pagination
              v-if="datosTabla.length > 0"
              align="center"
              v-model="paginaActual"
              :total-rows="totalNuevos"
              :per-page="registrosPorPagina"
              aria-controls="my-table1"
              @input="onPageChange"
          ></b-pagination>
        </b-tabs>
      </div>
    </b-card>

    <b-modal
      size="lg"
      v-model="programarActivdadesEnviar"
      id="modalAcciones"
      title="Acciones a realizar"
      hide-footer
      :no-close-on-backdrop="true"
    >
      <div>
        <b-row>
          <b-col>
            <b-table-simple class="mginTop15 divItemUno" hover responsive>
              <b-thead class="columnas">
                <b-tr>
                  <b-th>Contactos</b-th>
                  <b-th class="letraMayuscula text-center">.</b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <b-tr v-for="(item, i) in datosContacto" :key="i" :value="i">
                  <b-td class="columnas">
                    <div>{{ item.medioContacto }}</div>
                  </b-td>
                  <b-td class="parrafos">
                    <select class="divItemUno" disabled>
                      <option value selected hidden>
                        {{ item.contacto }}
                      </option>
                    </select>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-col>
        </b-row>

        <div>
          <label style="width: 100%">
            <b-row style="width: 100%">
              <b-col cols="6">Acción a ejecutar: <validacion /></b-col>
              <b-col cols="6" align="right"> </b-col>
            </b-row>
          </label>
        </div>
        <div>
          <div v-if="idTipoAccion == 2">
            <p>El paciente no debe de ser contactado por el motivo: {{accionEjecutada}}</p>
          </div>
          <div v-if="idTipoAccion == 1">
            <b-form-group  v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                :disabled="true"
                v-model="accionEjecutada"
                :options="options"
                :aria-describedby="ariaDescribedby"
                name="plain-inline"
                plain
              ></b-form-radio-group>
            </b-form-group>
          </div>
   

    <div>
      <p style="font-weight: 600">Observaciones:</p>
      <div v-if="observaciones != null && observaciones.length > 150">
        <b-button
        title="Detalle de observaciones"
        size="sm"
        @click="
          modalComentarios = true
        "
        variant="info"
        ><em class="fa fa-eye"></em
      ></b-button>
      </div>
      <div v-else>
        <p>{{observaciones}}</p>
      </div>
      
    </div>
          <!--<v-select
            :options="listaAccion"
            v-model="enviarAcciones.idAccion"
            label="descripcion"
            :reduce="(variable) => variable.idAccion"
            :state="enviarAcciones.idAccion != null"
          >
            <span slot="no-options">No hay coincidencias.</span>
          </v-select>
          <b-form-invalid-feedback :state="enviarAcciones.idAccion != null">
            Se debe escoger una acción
          </b-form-invalid-feedback>-->
        </div>

        <br />

        <div>
            
          <p style="font-weight: 600;">Comentario (*)</p>
          <b-form-group
            class="mginInputTrt"
            id="fieldset-9"
          >
            <b-form-textarea
              v-model="enviarAcciones.comentario"
              type="text"
              rows="3"
              max-rows="6"
              :state="enviarAcciones.comentario != null"
            ></b-form-textarea>
            <b-form-invalid-feedback :state="enviarAcciones.comentario != null">
              Se debe colocar un comentario
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
        <div style="padding: 15px" class="float-right">
          <b-button
            pill
            variant="info"
            :disabled="
              enviarAcciones.comentario == null ||
              btnDisabled == true ||
              loader
            "
            @click="guardarHistoricoAcciones()"
            >Guardar
            <span v-if="loader"><b-spinner small></b-spinner></span></b-button
          >
        </div>
      </div>
    </b-modal>

    <!--    Modal del Historico de Acciones -->

    <b-modal
      size="lg"
      v-model="mostrarModalHistoricoAcciones"
      id="historicoAcciones"
      title="Historico acciones ejecutadas"
      hide-footer
      :no-close-on-backdrop="true"
    >
      <div>
        <div>
          <div>
            <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="listaHistoricoAccionesIndexAgregado"
              :fields="fieldsHistorico"
              :per-page="registrosPorPagina"
              :current-page="1"
              sticky-header
              empty-text="No se encontraron registros"
                show-empty
            >
              <template v-slot:cell(fechaAlta)="row">
                {{ row.item.fechaAlta | formatoFechaHora }}
              </template>
              <template v-slot:cell(fechaFinalizacion)="row">
                {{row.item.fechaFinalizacion | formatoFechaHora}}
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal
      size="lg"
      v-model="modalActividad"
      id="historicoAcciones"
      title="Actividad asignada para paciente"
      hide-footer
      :no-close-on-backdrop="true"
    >
      <div>
        <label>Actividad a realizar: </label>
        <p>{{ infoActividad.comentarioActividadAsignada }}</p>
      </div>
    </b-modal>
    <b-modal
        v-model="modalComentarios"
        title="Observaciones"
        scrollable
        size="lg"
      >
        <p style="font-size: 18px; font-weight: 600">Observaciones de la actividad</p>
        <div class="container-fluid main-component p-3 text-justify">
          <p>{{ observaciones }}</p>
        </div>
      </b-modal>
  </div>
</template>

<script>
import Header from "@/components/Header";
import { required } from "vuelidate/lib/validators";
import XLSX from 'xlsx';

export default {
  name: "bandejaSeguimientoAnfitrion",
  components: { Header },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    modalComentarios: false,
    seleccionObservaciones: null,
    tipoBusqueda: 0,
    diasMaximoMes: null,
    btnDisabled: false,
    colorSinEstatusEnTiempo:[],
    listaHistoricoAcciones:[],
    listaHistoricoAccionesIndexAgregado:[],
    datosEmpeladosPerfiles:[{
      idEmpleado:null
    }],
    idClinica:null,
    banderaExito:false,
    programarActivdadesEnviar:false,
    mostrarModalHistoricoAcciones:false,
    loading:false,
    filtro: {
      fechaInicio: null,
      fechaFin: null,
      idEstatus: [],
      clinica: [],
      idPaciente: null,
      idPTI: null,
      idEstatusTx: []
    },
    listaClinicas: [],


    datosTabla: [],
    datosContacto:[],
    datosTablaAnfitrion:[],
    listaAccion:[],
    todosIdEstatus: [],

    enviarAcciones:{
      idAccion:null,
      comentario:null,
      idSolicitudBandejaAvpt: null,
      idPaciente: null,
      cc: false,
      idEstatus: 2,
      idDetalleAccionBandejaAvpt: null
    },


    sla: {
      idSla: null,
      idTipoSolicitud: null,
      sla: null,
      idEstatus: null,
      registroActivo: null,
    },
    tituloModal: "",
    show: false,
    modalAgregarEstatus: false,
    loader: false,
    fields: [
      { key: "fechaAceptacionPTI", label: "Fecha de aceptación PTI", sortable: true},
      { key: "clasificacion", label: "Clasificación PTI", sortable: true },
      { key: "estatus", label: "Estatus Pti", sortable: true },
      { key: "colorEstatus", label: "Estatus Tratamiento", sortable: true },
      { key: "strclinica", label: "Clinica", sortable: true },
      { key: "idPaciente", label: "ID Paciente", sortable: true },
      { key: "nombrePaciente", label: "Paciente", sortable: true },
      { key: "ultimaCita", label: "Ultima cita", sortable: true },
      { key: "proximaCita", label: "Proxima Cita", sortable: true },
      { key: "ultimoTratamiento", label: "Ultimo Tratamiento", sortable: true },
      { key: "proximoTratamiento", label: "Proximo Tratamiento", sortable: true },
      { key: "fechaProgramada", label: "Fecha Programada", sortable: true },
      { key: "doctorAsignado", label: "Doctor Asignado", sortable: true },
      { key: "empleadoActividad", label: "Empleado Realizar Actividad", sortable: true },
      { key: "fechaActividadAsignada", label: "Fecha de asignación actividad", sortable: true },
      { key: "comentarioActividadAsignada", label: "Actividad", sortable: true },
      { key: "programarActividad", label: "Realizar Actividad", sortable: true },
      { key: "idEstatusAccion", label: "Actividad Realizada", sortable: true },
      { key: "fechaActividadRealizada", label: "Fecha de actividad realizada", sortable: true },
      //{ key: "actividadRealizada", label: "Actividad Realizada", sortable: true },
      { key: "porcentajeFinanciero", label: "% Avpt Tx Financiero", sortable: true },
      // { key: "avanceFinanciero", label: "Avance Financiero", sortable: true },
      { key: "avanceSalud", label: "% AVPT Tx", sortable: true },

    ],

    fieldsHistorico: [
      { key: "id", label: "#", sortable: true },
      { key: "fechaAlta", label: "Fecha Asignación", sortable: true },
      { key: "descripcion", label: "Acción", sortable: true },
      { key: "comentario", label: "Comentario", sortable: true },
      { key: "descripcionEstatus", label: "Estatus", sortable: true },
      { key: "fechaFinalizacion", label: "fecha Realización", sortable: true },
    ],
    totalNuevos: null,
    totalConToken: null,
    registrosPorPagina: 20,
    paginaActual: 1,
    paginaActualContoken:1,
    colores: [],
    tiposSolicitud: [],
    loaderAcciones: false,
    datosGuardar: {
      idEstatus: null,
      nombreEstatus: null,
      proximaCita: true,
      slaMinimo: null,
      slaMaximo: null,
      registroActivo: true,
    },
    idEstatusFiltro: null,
    tabSeleccionada: 1,
    coloresOriginal: [],
    coloresFiltrado: [],
    dataExcel: [],
    modalActividad: false,
    infoActividad:{},
    datosExportar: [],
    idTipoAccion: null,
    options: [
          { text: 'Mail', value: "Mail"},
          { text: 'WhatsApp', value: "WhatsApp"},
          { text: 'Llamada', value: "Llamada"}
        ],
    accionEjecutada: null,
    observaciones: null,
    coloresTx: [
      {value: 1, nombre: "En tiempo", codigoColor: "#4CA23E"},
      {value: 2, nombre: "Por Vencer", codigoColor:  "#FBB917"},
      {value: 3, nombre: "Vencido", codigoColor: "#ff0000"},
      {value: 4, nombre: "PTI Finalizado", codigoColor: "#CCCCCC"}
    ],
    idEstatusFiltroTx: null
  }),
  validations: {
    sla: {
      idTipoSolicitud: { required },
      sla: { required },
      idEstatus: { required },
    },
    todas: true,
    buscar: false,

      filtro: {
        fechaInicio: {required},
        fechaFin: {required},
      }

  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    this.idClinica = this.$localStorageService.getIdClinica();
    this.loading=true;
    this.obtenerColores();
    this.llenarClinicas();
    this.obtenerAccionesBandejaAvpt();
    this.obtenerEmpleadosPerfiles();
    this.clear();
  },
  methods: {
    abrirModal(observaciones){
      this.modalComentarios = true;
      this.seleccionObservaciones = observaciones;
    },
    fechaMaxima(event){
      this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.filtro.fechaInicio = new Date(event);
      this.filtro.fechaFin = null;

    },
    mostrarModalActividad(items){
      this.modalActividad = true;
      this.infoActividad = items.item;

    },
    filtrarBandeja(tabSeleccionada){
      this.coloresFiltrado = [];
      this.idEstatusFiltro = [];
      if (tabSeleccionada == 1) {
        this.coloresFiltrado = this.coloresOriginal.filter(item => item.idEstatus == 1);
      }else{
        this.coloresFiltrado = this.coloresOriginal.filter(item => item.idEstatus !== 1);
      }
      this.coloresFiltrado.forEach(element => {this.idEstatusFiltro.push(element.idEstatus)});

      this.datosTabla = [];
      this.datosTablaAnfitrion = [];
      this.filtrado(false);


    },

    programarActivdiad(item){
      this.enviarAcciones.idSolicitudBandejaAvpt=item.idSolicitudBandejaAvpt;
      this.programarActivdadesEnviar = true;
      this.enviarAcciones.idPaciente = item.idPaciente;
      this.enviarAcciones.idEstatus = 2;
      this.enviarAcciones.idDetalleAccionBandejaAvpt = item.idDetalleAccionBandejaAvpt;
      this.accionEjecutada = item.comentarioActividadAsignada;
      this.idTipoAccion = item.idTipoAccion;
      this.observaciones = item.actividadAsignada != '' ? item.actividadAsignada : 'Sin observaciones';
      const parametros = {idPaciente: item.idPaciente}
      this.$http
          .post(this.$api + "paciente/obtener/contactos", parametros)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.datosContacto = respuesta.data.data;
            }
          })
          .finally(() => {

          });


    },

    
    consultarReporte(){
      this.loading=true;
      this.$swal.fire({
            title: "Este proceso podría tardar varios minutos, ¿desea continuar?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
            showLoaderOnConfirm: true,
            preConfirm: () => {
              this.$http
          .post(
            this.$api +
              "seguimiento/bandejaAvpt/obtenerDatosBandejaAvptAnfritrionExcel", this.filtro).then((respuesta) => {
                if (respuesta.status === 200) {
                  this.dataExcel =  respuesta.data.data.datosBandeja;
                  this.exportarExcel();
                }
              })

            },
            allowOutsideClick: () => !this.$swal.isLoading(),
          });

     
    },
     exportarExcel() {
      const fecha = this.$moment(new Date()).format('l')
      const newDate = fecha.split("/")
      var dia = newDate[0];
      var mes = newDate[1];
      var anio = newDate[2];

      let datosExcel = [];
      this.dataExcel.forEach(element => {
        
        let datos = {
          "Clasificación": element.clasificacion,
          "Estatus": element.estatus,
          "Clínica":element.strclinica,
          "ID de paciente":element.idPaciente.toString(),
          "Nombre de paciente": element.nombrePaciente,
          "Última cita": element.ultimaCita != null ? element.ultimaCita : 'Sin fecha',
          "Próxima cita": element.proximaCita != null ? this.$moment(new Date(element.proximaCita)).format('ll') : 'Sin fecha',
          "Último tratamiento":element.ultimoTratamiento != null ? element.ultimoTratamiento : 'Sin inicio de tratamiento',
          "Próximo tratamiento": element.proximoTratamiento != null ? element.proximoTratamiento : 'Sin próximo tx',
          "Empleado a Realizar Actividad": element.empleadoActividad,
          "Fecha programada": element.fechaProgramada != null ? element.fechaProgramada : 'Sin fecha',
          "Doctor asignado": element.doctorAsignado,
          "Fecha de asignación actividad": element.fechaActividadAsignada != null ? this.$moment(new Date(element.fechaActividadAsignada)).format('ll') : 'Sin fecha',
          "Actividad asignada": element.comentarioActividadAsignada,
          "Actividad realizada": element.idEstatusAccion == 1 ? 'No' : 'Sí',
          "Porcentaje AVPT Tx financiero": element.porcentajeFinanciero + '%',
          "Porcentaje AVPT Tx":element.avanceSalud + '%'
        }
        datosExcel.push(datos);

      });
      let data = XLSX.utils.json_to_sheet(datosExcel)
       const workbook = XLSX.utils.book_new()
      const filename = 'seguimiento_avpt_'+dia+'_'+mes+'_'+anio;
      XLSX.utils.book_append_sheet(workbook, data,"Nuevos", true)
      XLSX.writeFile(workbook, `${filename}.xlsx`)
       this.loading=false;
    },
    onPageChange(){
      this.filtrado(false);
    },
    onPageChangeConToken(){
      this.filtrado(false);
    },
    filtrado(buscar) {
      buscar ? this.paginaActual = 1 : this.paginaActual;
      this.datosTabla = [];
      if (this.tipoBusqueda == 1 && (this.filtro.fechaInicio == null || this.filtro.fechaFin == null || this.filtro.clinica.length == 0)) {
         this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: "Todos los campos son obligatorios, por favor verifique la información",
          });

      }else{
        this.loader=true;
        this.loading=true;
        if (this.idEstatusFiltro != null) {
            this.filtro.idEstatus = this.idEstatusFiltro;
          }else{
            this.filtro.idEstatus = this.todosIdEstatus
          }

          
        this.filtro.idsClinica = this.filtro.clinica;
        this.filtro.idEstatusTx =  this.idEstatusFiltroTx;
      this.$http
          .post(this.$api +  "seguimiento/bandejaAvpt/obtenerDatosBandejaAvptAnfritrionPaginada?pagina=" + this.paginaActual, this.filtro )
          .then((respuesta) => {

          if (respuesta.data.data) {
            this.datosTabla = respuesta.data.data.datosBandeja;
            this.totalNuevos = respuesta.data.data.total
            this.buscar = true;
            this.datosExportar=JSON.parse(JSON.stringify(this.datosTabla));
          }
        })
        .finally(() => {
          this.loading=false;
          this.loader = false;
        });
      }
    },
    todos() {
      this.todas = false;
      this.listaClinicas.forEach(element => {
        this.filtro.clinica.push(element.idClinica);
      });
    },

    clear() {
      this.todas = true;
      this.filtro.clinica = [];
      this.loading=false;
    },
    llenarClinicas() {
      this.listaClinicas = this.$localStorageService.getClinicas();
    },

    resetearDatos() {
      this.datosGuardar = {
        idEstatus: null,
        nombreEstatus: null,
        proximaCita: true,
        slaMinimo: null,
        slaMaximo: null,
        idColor: 0,
        registroActivo: true,
      };
    },
    obtenerEstatus() {
      this.loader = true;
      this.$http
        .get(this.$api + "seguimiento/bandejaAvpt/obtenerListaBandeja")
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.datosTabla = respuesta.data.data;
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },

      obtenerColores() {
             this.$http
        .get(this.$api + "seguimiento/bandejaAvpt/obtenerEstatusBandeja")
        .then((respuesta) => {
          if (respuesta.data.data) {
            this.coloresOriginal = respuesta.data.data;
            this.coloresFiltrado = this.coloresOriginal;
            this.coloresOriginal.forEach(element => {
              this.todosIdEstatus.push(element.idEstatus)
            });
           

          }
        });
    },
    guardarHistoricoAcciones() {
      this.loading = true;
      this.loader = true;
      if(this.enviarAcciones.comentario.trim() == ''){
        this.$swal.fire({
        position: "center",
        icon: "warning",
        title: "Los comentarios no pueden ir vacíos",
        showConfirmButton: true
      });
      }else{
        this.$http
          .post(this.$api + "avpt/guardarHisricoAcciones",this.enviarAcciones)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.banderaExito = respuesta.data.data;
              this.programarActivdadesEnviar = false;
              this.enviarAcciones.comentario=null;
              this.enviarAcciones.idAccion=null;
              this.filtrado();
              this.showAlert();
            }
          }).finally(() => {
            this.loader = false;
        this.loading = false;
        this.filtrado();
        this.programarActivdadesEnviar = false;
        this.setearDatos();
      });
      }
    },

    setearDatos(){
      this.enviarAcciones = {
        idAccion:null,
        comentario:null,
        idSolicitudBandejaAvpt: null,
        idPaciente: null,
        cc: false,
      };
    },
    validateState(name) {

      const { $dirty, $error } = this.$v.sla[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute);
      if (state) {
        return "border rounded-lg border-success";
      } else if (state === false) {
        return "border rounded-lg border-danger";
      } else {
        return "";
      }
    },
    obtenerEmpleadosPerfiles() {
      this.loader = true;
      const parametros = {idClinica: this.idClinica}
      this.$http
          .post(this.$api + "seguimiento/bandejaAvpt/encontrarClinicaEmpleadoBandejaAvpt", parametros)
          .then((respuesta) => {
            if (respuesta.data.data) {
              //this.datosEmpeladosPerfiles = respuesta.data.data;
              this.datosEmpeladosPerfiles.push(
                  ...respuesta.data.data
                      .map((it) => {
                        return {
                          idEmpleado: it.idEmpleado,
                          nombre:
                              it.nombreEmpleado +
                              " (" +
                              it.descricionPerfil
                              + ")",
                        };
                      }));
            }
          })
          .finally(() => {
            this.loader = false;
          });
    },


    obtenerAccionesBandejaAvpt() {
      this.$http
          .get(this.$api + "catalogos/accionesbandejaavpt/obtenerAccionesBandejaAvpt")
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.listaAccion = respuesta.data.data;

            }
          });
    },
    obtenerHistoricoAccionesBandejaAvpt(idSolicitud){
      var i=1;
      this.$http
          .get(this.$api + "avpt/obtenerHistoricoAccionesBandejaAvpt?idSolicitudBandeja=" + idSolicitud)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.listaHistoricoAcciones = respuesta.data.data;
              this.listaHistoricoAccionesIndexAgregado = [];
              /* let tamanio = this.listaHistoricoAcciones.length; */
             this.listaHistoricoAcciones.forEach( f =>{

                    this.listaHistoricoAccionesIndexAgregado.push({
                      id: i,
                      comentario: f.comentario,
                      descripcion: f.descripcion,
                      fechaAlta: f.fechaAlta,
                      idAccion: f.idAccion,
                      idSolicitudBandejaAvpt: f.idSolicitudBandejaAvpt,
                      descripcionEstatus: f.descripcionEstatus,
                      fechaFinalizacion: f.fechaFinalizacion
                    });
                    i++;
                  });
            }else{
              this.listaHistoricoAcciones = [];
              this.listaHistoricoAccionesIndexAgregado = [];
            }
          }).finally(() => {
            this.mostrarModalHistoricoAcciones=true;
      });
    },
    showAlert() {
      this.$swal.fire({
        position: "center",
        icon: "success",
        title: "Se guardo con éxito",
        showConfirmButton: true
      });
    },
    cambioFiltro(tipoFiltro){
       if(tipoFiltro === 1){ //filtro por fechas
        this.filtro.idPaciente  = null;
        this.filtro.idPTI = null;
       }else if(tipoFiltro === 2){ //filtro de pti
        this.filtro.clinica = [];
        this.filtro.fechaInicio = null;
        this.filtro.fechaFin = null;
        this.filtro.idPaciente  = null;
         this.todas =true;
       } else if(tipoFiltro === 3){ //filtro por px
        this.filtro.clinica = [];
        this.filtro.fechaInicio = null;
        this.filtro.fechaFin = null;
        this.filtro.idPTI = null;
         this.todas =true;
       }
    }
  },
  watch: {
    currentPage() {
      this.getNotifications(this.currentPage, true);
    },

    tabSeleccionada: function (val) {
        this.filtrarBandeja(val);

    }

  }
};
</script>

<style scoped>
.bCardGlobal {
  margin: 2% 4% 2% 4%;
  padding: 0.5% 1% 0.5% 1%;
  border-radius: 20px;
}

.divSubtitulo {
  width: 100%;
  margin-top: 2%;
  margin-bottom: 2%;
  border-bottom: 5px solid #8ec6e9;
}

.divInput {
  margin-left: 1%;
  margin-right: 3%;
}

.textSubtitulo {
  color: #093974;
  font-weight: 600;
  font-size: 22px;
  text-align: left;
}

.overflow-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.scroll-area {
  position: relative;
  margin: auto;
  height: 500px;
}
.scrollme {
  overflow-x: auto;
}
</style>
